export default __webpack_public_path__ + "static/media/vaporDreams.6655e673.gif";